export default function ChatLayout({ children, pageStyle, containerStyle }) {
    return (
        <div style={pageStyle}>
            <div style={containerStyle}>{children}</div>
        </div>
    );
}
